import React, { useState, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getHeatColor } from "utils/dashboardUtils";

const ThroughputHeatmap = () => {
  const { t } = useTranslation();

  const chartsData = useSelector(
    (state) => state.Dashboard?.data?.charts
  );

  const heatMap = chartsData?.hourlyHeatMap;

  const DAYS = useMemo(() => {
    if (!heatMap) return [];
    return Object.values(heatMap.dayMap);
  }, [heatMap]);

  const HOURS = heatMap?.hours ?? [];

  const MATRIX = heatMap?.matrix ?? {};

  if (!heatMap) return null; // or loader

  return (
    <div className="heatmap_container">
      <div className="heatmap_top">
        <div>
          <h3 className="fs_20">{t("Throughput by Hour")}</h3>
          <p className="page_sub_title mt-2">
            {t("Weekly hourly activity heat map")}
          </p>
        </div>

        <div className="heatmap_legend">
          <span className="legend_label">{t("Low")}</span>
          <div className="legend_colors">
            <span className="legend_box low" />
            <span className="legend_box mid1" />
            <span className="legend_box mid2" />
            <span className="legend_box high" />
          </div>
          <span className="legend_label">{t("More")}</span>
        </div>
      </div>

      <div className="inner_wrapper">
        {/* Header */}
        <div className="heatmap_header">
          <div className="heatmap_day_col" />
          <div className="heatmap_hours">
            {HOURS.map((hour) => (
              <span key={hour}>{hour}</span>
            ))}
          </div>
        </div>

        {/* Body */}
        <div className="heatmap_body">
          {DAYS.map((day) => (
            <div key={day} className="heatmap_row">
              <span className="heatmap_day">{day}</span>

              <div className="heatmap_cells">
                {MATRIX[day]?.map((value, i) => (
                  <OverlayTrigger
                    key={i}
                    placement="top"
                    overlay={
                      <Tooltip id={`${day}-${i}`}>
                        <strong>{day}</strong> · {HOURS[i]}
                        <br />
                        {t("Throughput:")} {value}%
                      </Tooltip>
                    }
                  >
                    <div
                      className="heatmap_cell"
                      style={{ background: getHeatColor(value) }}
                    >
                      {value}%
                    </div>
                  </OverlayTrigger>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ThroughputHeatmap;
